import React, { useState, useEffect, useReducer } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';

// CSS
import styles from '@UILayer/UILayer.scss';

// MANAGERS
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';

const GambleButton: React.FC<{ uiFreeze: boolean }> = ({ uiFreeze }) => {
    const [state, setState] = useReducer((state: { active: boolean }, newState: any) => ({ ...state, ...newState }), { active: false });

    const globalStyles = useAppSelector(getGlobalStyles);
    const { t } = useTranslation();

    const buttonCN = cn(
        styles.gamble_btn,
        styles.gameplay_btn,
        styles.gameplay_btn_type2,
        globalStyles.orientation,
        globalStyles.wcaMode,
        uiFreeze ? styles.disabled : null
    );

    useEffect(() => {}, []);

    function buttonAction(e: React.MouseEvent<any>) {
        if (!uiFreeze) {
            if (e) e.stopPropagation();
            EventsCenter.emit(EButtonEvents.GAMBLE_BUTTON_PRESSED);
        }
    }

    return (
        <button
            tabIndex={0}
            className={buttonCN}
            id="ui_button_gamble"
            aria-description={t('WCA_GAMBLE_MODE_BUTTON')}
            onKeyDown={(e) => KeyboardEventCheck(e, buttonAction)}
            onPointerDown={(e) => buttonAction(e)}
        ></button>
    );
};

export default GambleButton;
